export default {
  name: "BolideAssistantButton",
  emits: ["open-assistant"],   // ✅ FIX
};
